import React, { useState, useEffect } from 'react';
import axios from 'axios';
import style from './ChangeLogModal.module.sass';

const ChangeLogModal = ({ onClose }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLog();
  }, []);

  const fetchLog = async () => {
    try {
      const response = await axios.get('/api/v1/calendar_jobs/change_log');
      setEntries(response.data.entries || []);
    } catch (error) {
      console.error('Failed to fetch change log:', error);
    }
    setLoading(false);
  };

  return (
    <div className={style.overlay} onClick={onClose}>
      <div className={style.modal} onClick={(e) => e.stopPropagation()}>
        <div className={style.header}>
          <h2>Change Log</h2>
          <button className={style.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={style.content}>
          {loading ? (
            <div className={style.loading}>Loading...</div>
          ) : entries.length === 0 ? (
            <div className={style.empty}>No log entries yet</div>
          ) : (
            <div className={style.logEntries}>
              {entries.map((entry, index) => (
                <div key={index} className={style.logEntry}>
                  {entry}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className={style.footer}>
          <button className={style.refreshButton} onClick={fetchLog}>
            Refresh
          </button>
          <button className={style.closeModalButton} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeLogModal;
